import { NgModule } from '@angular/core';

import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeURLPipe } from './safe-url.pipe';

@NgModule({
  declarations: [
      SafeHtmlPipe,
      SafeURLPipe,
  ],
  exports: [
      SafeHtmlPipe,
      SafeURLPipe,
  ]
})
export class PipesModule { }
